import { runtimeConfig } from './environment-runtime.ts';

interface Environment {
  production: boolean;
  apiUrl: string;
  apiKey?: string;
  appVersion?: string;
  appName: string;
  muiLicenseKey: string;
  reownAppId: string;
  sentryDsn?: string;
  sentryEnvironment?: string;
  posthogKey?: string;
  posthogHost?: string;
  xTwitterClientKey?: string;
  funBridgeApiKey?: string;
  analyticsSalt?: string;
  statusPageUrl?: string;
}

export const environment: Environment = {
  production: import.meta.env.MODE === 'production',
  apiUrl: (import.meta.env.VITE_API_URL as string) || runtimeConfig.apiUrl,
  appVersion: import.meta.env.VITE_APP_VERSION as string,
  appName: 'Perpl',
  muiLicenseKey: (import.meta.env.VITE_MUI_LICENSE_KEY as string) || runtimeConfig.muiLicenseKey,
  reownAppId: (import.meta.env.VITE_REOWN_APP_ID as string) || runtimeConfig.reownAppId,
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string) || runtimeConfig.sentryDsn,
  sentryEnvironment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) || runtimeConfig.sentryEnvironment,
  posthogKey: (import.meta.env.VITE_POSTHOG_KEY as string) || runtimeConfig.posthogKey,
  posthogHost: (import.meta.env.VITE_POSTHOG_HOST as string) || runtimeConfig.posthogHost,
  xTwitterClientKey: (import.meta.env.VITE_TWITTER_CLIENT_ID as string) || runtimeConfig.xTwitterClientKey,
  funBridgeApiKey: (import.meta.env.VITE_FUNBRIDGE_API_KEY as string) || runtimeConfig.funBridgeApiKey,
  analyticsSalt: (import.meta.env.VITE_ANALYTICS_SALT as string) || runtimeConfig.analyticsSalt,
  statusPageUrl: (import.meta.env.VITE_STATUS_PAGE_URL as string) || runtimeConfig.statusPageUrl,
};
